<template>
  <div class="card" style="margin-bottom:64px">
    <a-alert :message="variantInfo.variantStatus|statusFormat" type="info" show-icon :description="mdseInfo.auditFailReason"  />
    <div class="price-box">
      <div class="price-title">
        <span>价格信息</span>
      </div>
      <div class="link-box">
        <label >商品链接：</label>
        <a-input placeholder="请输入" style="width:552px" v-model="variantInfo.itemUrl"></a-input>
        <a-button type="primary" :loading="textLoading" @click="test(variantInfo.itemUrl)">检测</a-button>
        <a :href="variantInfo.itemUrl" target="_blank">打开链接</a>
        <span class="tip">请勿频繁操作检测按钮</span>
      </div>
      <div class="price-header">
        <span>渠道价(元)
          <template>
            <a-popover :getPopupContainer="
          triggerNode => {
            return triggerNode.parentNode || document.body;
          }">
              <template slot="title">
                <p>渠道价默认计算规则：</p>
                <p>渠道价 =（商品链接价-进货价）* 10%+进货价</p>
              </template>
              <a-icon type="exclamation-circle" />
            </a-popover>
          </template>
        </span>
        <span>商品链接价(元)</span>
        <span>进货价(元)
          <a-tooltip placement="bottom"
              :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body;
              }
            ">
            <span slot="title">从供应商进货的价格</span>
            <a-icon type="exclamation-circle" />
          </a-tooltip>
        </span>
      </div>
      <div class="price-body"  >
        <edit-cell :price="variantInfo.distributePrice|toFixed2" mode="1" :isShow="variantInfo.preDistributePrice!='0'&&variantInfo.distributePrice!=variantInfo.preDistributePrice" :isRise="variantInfo.distributePrice>variantInfo.preDistributePrice" @getdata="getdata"></edit-cell>
        <edit-cell :price="variantInfo.itemPrice|toFixed2"  mode="2" @getdata="getdata"></edit-cell>
        <span >{{variantInfo.supplyPrice|toFixed2}}</span>
      </div>
      <div class="price-bottom">
        <div class="item" v-show="data.itemPrice&&data.itemPrice<data.supplyPrice">
          <label style="color:#FF4D4F"><div class="icon"><a-icon type="exclamation-circle"  /></div><span>商品链接价低于进货价</span> </label>
        </div>
        <div class="item">
          <label ><div class="icon"><a-icon type="exclamation-circle" /></div>
          <span>当前渠道价 =（商品链接价-进货价）* <span style="color:#0254D3;text-decoration:underline "  > 
            <span v-if="variantInfo.grossMargin">
              <edit-cell :price="variantInfo.grossMargin"  mode="3" @getdata="getdata"></edit-cell>
            </span>
            <span v-else>-</span> </span> %+进货价</span>  </label>
          <span v-show="variantInfo.preDistributePrice&&variantInfo.distributePrice!=variantInfo.preDistributePrice">
            <a-icon type="rise" v-if="variantInfo.distributePrice>variantInfo.preDistributePrice"  :style="{ fontSize: '16px', color: 'rgb(255,50,50)',marginLeft:'10px' }" />
            <a-icon type="fall" v-else :style="{ fontSize: '16px', color: 'rgb(13,237,125)',marginLeft:'10px' }" />
        </span>  
        </div>
        <div class="item">
          <label ><div class="icon"><a-icon type="exclamation-circle" /></div><span>历史渠道价:{{variantInfo.preDistributePrice|toFixed2}}</span> 
          </label>
        </div>
      </div>
    </div>
    <a-descriptions title="商品信息" class="product_info">
      <a-descriptions-item label="商品名称" span="3">
        {{mdseInfo.mdseName}}  
      </a-descriptions-item>
      <a-descriptions-item label="大类">
        {{mdseInfo.primaryCategoryName||'-'}}
      </a-descriptions-item>
      <a-descriptions-item label="小类">
        {{mdseInfo.categoryNodeList|subcategoryF}}
      </a-descriptions-item>
      <a-descriptions-item label="提交时间">
        {{mdseInfo.createTime||'-'}}
      </a-descriptions-item>
      <a-descriptions-item label="品牌" span='3'>
        {{mdseInfo.brand||'-'}}
      </a-descriptions-item>
      <a-descriptions-item label="供应商账号名">
        {{mdseInfo.supplierAlias||'-'}}
      </a-descriptions-item>
      <a-descriptions-item label="供应商手机号">
        {{mdseInfo.supplierAccount||'-'}}
      </a-descriptions-item>
      <a-descriptions-item label="提交人">
        {{mdseInfo.supplierAccount||'-'}}
      </a-descriptions-item>
      <a-descriptions-item label="商品主图">
        <div class="img_main">
          <div class="img_item" v-for="(item,index) in mdseInfo.mdseImgPathList" :key="index">
            <img :src="item" ></img>
          </div>
        </div>
      </a-descriptions-item>
    </a-descriptions>

    <div class="sku_box">
      <div class="price-title">
        <span >规格信息</span>
      </div>
      <a-table :data-source="skudata" rowKey="id" :pagination='false'>
        <a-table-column  title="SKU图" data-index="skuImgPath" >
           <template slot-scope="skuImgPath" >
              <img :src="skuImgPath" alt="" class="sku_img">
          </template>
        </a-table-column>
        <a-table-column  :title="item" :data-index="item" v-for="(item,index) in headers" :key="index">
        </a-table-column>
        <a-table-column title="库存"  data-index="stockNum">
        </a-table-column>
        <a-table-column title="进货价（元）" data-index="supplyP">
          <template slot-scope="supplyP" >
            {{supplyP.supplyPrice|toFixed2}} <br/>
            {{supplyP.supplyPriceType=='1'?'含税含运价':'含税价'}}<br>  
          </template>
        </a-table-column>
      </a-table>
        <a-descriptions  >
          <a-descriptions-item  label="详情页" :span="3" >
            <div class="detail_img">
              <img :src="item" v-for="item in variantInfo.detailImgPathList" alt="">
            </div>
          </a-descriptions-item>
          <a-descriptions-item :label="item.name" v-for="(item, index) in variantInfo.variantParamObjectList" :key="index">
            {{item.value||'-'}}  
          </a-descriptions-item>
        </a-descriptions>
    </div>
    
    <div class="price-box" v-show="data.status=='40'">
      <div class="price-title">
        <span>渠道商</span>
      </div>
      <div class="price-header">
        <span>渠道商账号名</span>
        <span>渠道商手机号</span>
      </div>
      <div class="price-body" >
        <div v-for="item in business">
          <span>{{item.alias||'-'}}</span>
          <span>{{item.account||'-'}}</span>
        </div>
        
      </div>
    </div>  

  </div>
</template>

<script>
import editCell from "./components/editCell";
export default {
  name: "productD",
  components: { editCell },
  data() {
    return {
      skudata: [],
      data: {},
      business: [],
      mdseInfo: {},
      variantInfo: {},
      variantNameObjectList: [],
      headers:[],
      textLoading:false,
    };
  },
  created() {
    this.getdata();
  },
  filters: {
    statusFormat(value) {
      switch (value) {
        case 10:
          return "待审核";
          break;
        case 20:
          return "审核不通过";
          break;
        case 30:
          return "审核通过";
          break;
        case 40:
          return "预警商品";
          break;
        case 50:
          return "已下架";
          break;
      }
    },
    subcategoryF(value) {
      if (!(value instanceof Array)) {
        return "--";
      }
      let label = "";
      value.forEach(item => {
        label += item.name + "、";
      });
      return label.substr(0, label.length - 1);
    },
  },
  methods: {
    // 链接检测
    test(url) {
      this.textLoading = true;
      let params = {
        variantId: this.$route.query.id,
        itemUrl: url
      };
      this.$http.post("merchandise/getItemPrice", params).then(res => {
        if (res.result) {
          this.$message.success("检测成功");
          this.getdata();
        } else {
          this.$message.success(res.message);
        }
        this.textLoading = false;
      });
    },
    getdata() {
      let params = {
        variantId: this.$route.query.id
      };
      this.$http.get("merchandise/getVariantDetails", { params }).then(res => {
        this.variantInfo = res.data.variantInfo;
        this.mdseInfo = res.data.mdseInfo;
        let headers = res.data.mdseInfo.variantCombineObject.headers || [];
        let skuItem = {};
        const values = res.data.variantInfo.variantNameObject.values;
        values.forEach((item,index) => {
          skuItem[headers[index]] = item;
        });
        skuItem.skuImgPath = this.variantInfo.skuImgPath;
        skuItem.stockNum = this.variantInfo.stockNum;
        skuItem.supplyP = {
          supplyPrice: this.variantInfo.supplyPrice,
          supplyPriceType: this.variantInfo.supplyPriceType
        };
        skuItem.id = 1;
        this.skudata = [skuItem];
        this.headers =headers;
        // console.log(this.data&&this.data.status == '40');
        // this.data && this.data.status == "40" && this.getChannelBusiness();
      });
    },
    getChannelBusiness() {
      let url = "merchandise/getLicDistributors?mdseId=" + this.$route.query.id;
      this.$http.get(url).then(res => {
        this.business = res.rows;
      });
    },
    changeActive($event) {
      $event.currentTarget.className = "active";
    },
    openModal(index, params) {
      this.$refs.transferDetail.showModal([this.$route.query.id]);
    }
  }
};
</script>

<style lang="less" scoped>
.product_info {
  /deep/.ant-descriptions-row:last-child {
    .ant-descriptions-item-label {
      vertical-align: top;
    }
    .img_main {
      display: flex;
      .img_item {
        margin-right: 12px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        img {
          width: 104px;
          height: 104px;
        }
      }
    }
  }
}
.sku_box {
  margin-top: 16px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 1);
  .price-title {
    padding-bottom: 20px;
  }
  /deep/.ant-descriptions-row:first-child {
    .ant-descriptions-item-label {
      vertical-align: top;
    }
  }
  .detail_img {
    img {
      margin-right: 12px;
      width: 104px;
      height: 104px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
    }
  }
  .sku_img {
    width: 64px;
    height: 64px;
  }
}

.tip {
  display: inline-block;
  margin-left: 16px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.25);
  line-height: 22px;
}
.card {
  margin: 0 24px;
}
.price-header {
  /deep/.ant-popover-inner-content {
    display: none;
  }
  /deep/.ant-popover-title {
    padding-top: 20px;
  }
  /deep/.ant-popover-placement-bottomLeft {
    .ant-popover-message-title {
      padding: 0;
    }

    .ant-popover-buttons {
      display: none;
    }
    .anticon-exclamation-circle {
      display: none;
    }
  }
}

/deep/.ant-tooltip-inner {
  span {
    padding: 0px !important;
  }
}

.price-title {
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-weight: bold;
}
.logistics-info {
  margin-right: 0 !important;
}
.link-top {
  padding: 0 6px;
  height: 1px;
  border-top: 1px solid rgba(229, 229, 229, 1);
}
.ant-descriptions {
  border-radius: 2px;
  margin-top: 16px;
  background-color: #ffffff;
  padding: 20px 24px;
}
.price-box {
  border-radius: 2px;
  margin-top: 16px;
  // margin-bottom: 50px;
  background-color: #ffffff;
  padding: 20px 24px;
  .link-box {
    padding: 16px 0;
    .ant-btn-primary {
      margin: 0 16px;
    }
  }
  .price-header {
    font-weight: 500;
    background-color: rgba(250, 250, 250, 1);
    border-bottom: 1px solid #e8e8e8;
  }
  .price-header,
  .price-body {
    position: relative;
    span {
      padding: 16px 24px;
      display: inline-block;
      width: calc((90%-48px) / 3);
    }
  }
}
.price-bottom {
  position: relative;
  border-top: 1px solid rgba(229, 229, 229, 1);
  padding: 20px 0;
  .item {
    margin-bottom: 12px;
  }
  label {
    padding: 4px 0px;
    height: 22px;
    line-height: 22px;
  }
  .icon {
    display: inline-block;
    width: 24px;
  }
}

.btn-box {
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  margin-top: 16px;
  background-color: #fff;
  height: 64px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  .ant-btn-primary {
    margin-right: 16px;
  }
}

/deep/ .ant-popover-inner-content {
  min-width: 216px;
  height: 64px;
  padding: 16px 12px;
}
</style>